import { useState, useEffect } from "react";
import {Typography, Grid, Divider } from '@mui/material';
import { useTheme } from '@mui/material';
import { useAuth } from "../../provider";
import axios from "axios";
import * as c from '../../constants';



export default function SectionLabvisitGroups(props) {

    const {state} = useAuth()
    const theme = useTheme()
    const {sectionsubtext, cycleday, cyclephase, sectioncards, selectedDate, markerList} = props

     const url_blood = `${c.API_URL}/markers/analysis/`; 

     const [data, setData] = useState(null);

   // fetch analysis of markerList (green, orange, red)
  useEffect(() => {
    if (!selectedDate) return;

    const fetchAnalysis = async () => {
      try {
        const response = await axios.post(url_blood, {
          markers: markerList,
          date: selectedDate || null,
        });
        setData(response.data);
      } catch (error) {
        console.error("Error loading marker analysis:", error);
      }
    };

    if (markerList?.length > 0) fetchAnalysis();
  }, [markerList, selectedDate]);

  if (!data) return null;

    const { green, orange, red } = data;
    const total = green + orange + red;

return (
<>    

<Grid container sx={{mt:4, minWidth: 400, display:'flex', justifyContent:'center', alignItems: 'flex-start'}}>

{/* Left Side */}   
    <Grid size={4} sx={{mb:0.5, display:'flex', justifyContent:'center', alignItems: 'center'}}> 
        <Grid container sx={{ py: 1, textAlign: "center" }}>

            <Grid size={12} sx={{mb:0.5, display:'flex', justifyContent:'center', alignItems: 'center'}}> 
                <Typography variant="subtitle1" sx={{ fontWeight: 400, }}>{sectionsubtext} </Typography>
            </Grid>
            
            {/* Display Date of Labvisit */}  
            <Grid size={12} sx={{mb:2, display:'flex', justifyContent:'center', alignItems:'center'}}> 
                <Typography variant="subtitle2" sx={{fontWeight:400}}>Labvisit Day: {selectedDate}   </Typography> 
           </Grid>

            {/* Conditional: Only Female --> Cycle Info */}  
            {state.user.gender == "F" &&
            <>
            <Grid size={12} sx={{width: '100%', display:'flex', justifyContent:'center', alignItems:'center'}}> 
                <Typography variant="subtitle2" sx={{}}>Cycle Day: {cycleday}   </Typography> 
            </Grid>  
                
            <Grid size={12} sx={{mb:2, width: '100%',display:'flex', justifyContent:'center', alignItems:'center'}}> 
                <Typography variant="subtitle2" sx={{}}>Cycle Phase: {cyclephase}   </Typography> 
            </Grid>  
            </>
            }
       

        <Grid size={12} sx={{mt:2, display:'flex', justifyContent:'center', alignItems:'center'}}> 

              {/* --- SUMMARY TEXT: Normal, Sufficient, Out of Range --- */}

          <Grid container sx={{pt:1, pr:4, display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', }}>
           
           <Grid size={7} sx={{pt:1, display:'flex', justifyContent:'flex-end', alignItems:'flex-end'}}> 
                    <Typography variant="body2" sx={{ fontWeight: 600,letterSpacing: 0.4, px: 1, py: 0.7, borderRadius: 2, bgcolor: "traffic.green", color: 'common.white',  }}> NORMAL</Typography>
            </Grid> 
             <Grid size={4} sx={{display:'flex', justifyContent:'flex-end', alignItems:'flex-start'}}>  
              <Typography variant="number" sx={{ fontWeight:400}}> {green}</Typography>
            </Grid>
             <Grid size={7} sx={{pt:1, display:'flex', justifyContent:'flex-end', alignItems:'flex-end'}}> 
                <Typography variant="body2" sx={{ fontWeight: 600,letterSpacing: 0.4, px: 1.5,py: 0.7,borderRadius: 2,bgcolor: "traffic.orange", color: 'common.white',  }}> SUFFICIENT</Typography>
            </Grid>  
             <Grid size={4} sx={{display:'flex', justifyContent:'flex-end', alignItems:'flex-start'}}>  
               <Typography variant="number" sx={{fontWeight:400}}> {orange}</Typography>
              </Grid>  
               <Grid size={7} sx={{pt:1, display:'flex', justifyContent:'flex-end', alignItems:'flex-end'}}> 
                <Typography variant="body2" sx={{ fontWeight: 600,letterSpacing: 0.4, px: 1.5,py: 0.7,borderRadius: 2,bgcolor: "traffic.red", color: 'common.white',  }}> OUT OF RANGE</Typography>
            </Grid>
            <Grid size={4} sx={{display:'flex', justifyContent:'flex-end', alignItems:'flex-start'}}>              
              <Typography variant="number" sx={{ fontWeight:400}}> {red}</Typography>
            </Grid>

        </Grid>



    </Grid>
     </Grid>  
    </Grid>

            {/* Vertical Divider */}
            <Divider orientation="vertical" flexItem sx={{borderColor: "greydark.C800", borderRightWidth: 1, my: 2, opacity: 0.9  }}/>

    {/* Right Side */}  
    <Grid size={7.5} sx={{mb:0.5, display:'flex', justifyContent:'center', alignItems: 'center'}}> 
        <Grid container sx={{ px:4, py:2, minWidth: 400, display:'flex', justifyContent:'center', alignItems: 'flex-start'}}>
            {/* Marker Cards */}   
            <Grid size={12} sx={{ mb:0, display:'flex', justifyContent:'center', alignItems:'center'}}>
                {sectioncards}
            </Grid>
        </Grid>
    </Grid>

</Grid>

</>
)
}